// ============================================================================
// gamificationEvents — thin façade that forwards into the ExperienceEngine
// ----------------------------------------------------------------------------
// Core canvas components fire-and-forget through these helpers; the
// ExperienceEngine subscribes via emitExperienceEvent. Kept here for migration
// ergonomics — callers that pre-date the engine still use the familiar
// emitTrackEvent / emitWorkAction signatures.
// ============================================================================

import type { ActivityTrackId } from '../types/schema'
import { emitExperienceEvent } from './experienceEvents'

export type WorkActionKind = 'CHECKLIST_COMPLETE' | 'TASK_COMPLETE' | 'FOCUS_BLOCK'

export interface WorkActionEvent {
  kind: WorkActionKind
  workspaceId: string
  subNodeId?: string
  userEmail?: string
  userDisplayName?: string
}

export const emitTrackEvent = (trackId: ActivityTrackId, increment = 1): void => {
  emitExperienceEvent(trackId, { increment })
}

export const emitWorkAction = (event: WorkActionEvent): void => {
  emitExperienceEvent(event.kind, {
    workspaceId: event.workspaceId,
    subNodeId: event.subNodeId,
    sourceId: event.subNodeId,
  })
}
